<template>
  <div>
    <div v-if="editText">
      <editor-menu-bar :editor="editor" v-slot="{ commands, isActive }">
        <div class="menubar buttons" style="margin: 0;">
          <button
            type="button"
            class="button is-small tooltip"
            data-tooltip="Bold"
            :class="{ 'is-active': isActive.bold() }"
            @click="commands.bold"
            v-if="toolbars.indexOf('bold') > -1"
          >
            <span class="icon">
              <i class="fas fa-bold"></i>
            </span>
          </button>

          <button
            type="button"
            class="button is-small tooltip"
            data-tooltip="Italic"
            :class="{ 'is-active': isActive.italic() }"
            @click="commands.italic"
            v-if="toolbars.indexOf('italic') > -1"
          >
            <span class="icon">
              <i class="fas fa-italic"></i>
            </span>
          </button>

          <button
            type="button"
            class="button is-small tooltip"
            data-tooltip="Strike"
            :class="{ 'is-active': isActive.strike() }"
            @click="commands.strike"
            v-if="toolbars.indexOf('strike') > -1"
          >
            <span class="icon">
              <i class="fas fa-strikethrough"></i>
            </span>
          </button>

          <button
            type="button"
            class="button is-small tooltip"
            data-tooltip="Underline"
            :class="{ 'is-active': isActive.underline() }"
            @click="commands.underline"
            v-if="toolbars.indexOf('underline') > -1"
          >
            <span class="icon">
              <i class="fas fa-underline"></i>
            </span>
          </button>

          <button
            type="button"
            class="button is-small tooltip"
            data-tooltip="Label"
            :class="{ 'is-active': isActive.code() }"
            @click="commands.code"
            v-if="toolbars.indexOf('code') > -1"
          >
            <span class="icon">
              <i class="fas fa-tag"></i>
            </span>
          </button>

          <button
            type="button"
            class="button is-small tooltip"
            data-tooltip="Paragraph"
            :class="{ 'is-active': isActive.paragraph() }"
            @click="commands.paragraph"
            v-if="toolbars.indexOf('paragraph') > -1"
          >
            <span class="icon">
              <i class="fas fa-paragraph"></i>
            </span>
          </button>

          <button
            type="button"
            class="button is-small tooltip"
            data-tooltip="Heading 1"
            :class="{ 'is-active': isActive.heading({ level: 1 }) }"
            @click="commands.heading({ level: 1 })"
            v-if="toolbars.indexOf('heading1') > -1"
          >
            <span class="icon">
              H1
            </span>
          </button>

          <button
            type="button"
            class="button is-small tooltip"
            data-tooltip="Heading 2"
            :class="{ 'is-active': isActive.heading({ level: 2 }) }"
            @click="commands.heading({ level: 2 })"
            v-if="toolbars.indexOf('heading2') > -1"
          >
            <span class="icon">
              H2
            </span>
          </button>

          <button
            type="button"
            class="button is-small tooltip"
            data-tooltip="Heading 3"
            :class="{ 'is-active': isActive.heading({ level: 3 }) }"
            @click="commands.heading({ level: 3 })"
            v-if="toolbars.indexOf('heading3') > -1"
          >
            <span class="icon">
              H3
            </span>
          </button>

          <button
            type="button"
            class="button is-small tooltip"
            data-tooltip="Align Left"
            @click="commands.paragraph({ textAlign: 'left' })"
            v-if="toolbars.indexOf('paragraph_left') > -1"
          >
            <span class="icon">
              <i class="fas fa-align-left"></i>
            </span>
          </button>

          <button
            type="button"
            class="button is-small tooltip"
            data-tooltip="Align Center"
            @click="commands.paragraph({ textAlign: 'center' })"
            v-if="toolbars.indexOf('paragraph_center') > -1"
          >
            <span class="icon">
              <i class="fas fa-align-center"></i>
            </span>
          </button>

          <button
            type="button"
            class="button is-small tooltip"
            data-tooltip="Align Right"
            @click="commands.paragraph({ textAlign: 'right' })"
            v-if="toolbars.indexOf('paragraph_right') > -1"
          >
            <span class="icon">
              <i class="fas fa-align-right"></i>
            </span>
          </button>

          <button
            type="button"
            class="button is-small tooltip"
            data-tooltip="Align Justify"
            @click="commands.paragraph({ textAlign: 'justify' })"
            v-if="toolbars.indexOf('paragraph_justify') > -1"
          >
            <span class="icon">
              <i class="fas fa-align-justify"></i>
            </span>
          </button>

          <button
            type="button"
            class="button is-small tooltip"
            data-tooltip="Bullet List"
            :class="{ 'is-active': isActive.bullet_list() }"
            @click="commands.bullet_list"
            v-if="toolbars.indexOf('bullet_list') > -1"
          >
            <span class="icon">
              <i class="fas fa-list-ul"></i>
            </span>
          </button>

          <button
            type="button"
            class="button is-small tooltip"
            data-tooltip="Order List"
            :class="{ 'is-active': isActive.ordered_list() }"
            @click="commands.ordered_list"
            v-if="toolbars.indexOf('ordered_list') > -1"
          >
            <span class="icon">
              <i class="fas fa-list-ol"></i>
            </span>
          </button>

          <button
            type="button"
            class="button is-small tooltip"
            data-tooltip="Blockquote"
            :class="{ 'is-active': isActive.blockquote() }"
            @click="commands.blockquote"
            v-if="toolbars.indexOf('blockquote') > -1"
          >
            <span class="icon">
              <i class="fas fa-quote-right"></i>
            </span>
          </button>

          <button
            type="button"
            class="button is-small tooltip"
            data-tooltip="Line"
            @click="commands.horizontal_rule"
            v-if="toolbars.indexOf('horizontal_rule') > -1"
          >
            <span class="icon">
              <i class="fas fa-minus"></i>
            </span>
          </button>

          <button
            type="button"
            class="button is-small tooltip"
            data-tooltip="Undo"
            @click="commands.undo"
            v-if="toolbars.indexOf('undo') > -1"
          >
            <span class="icon">
              <i class="fas fa-undo"></i>
            </span>
          </button>

          <button
            type="button"
            class="button is-small tooltip"
            data-tooltip="Redo"
            @click="commands.redo"
            v-if="toolbars.indexOf('redo') > -1"
          >
            <span class="icon">
              <i class="fas fa-redo"></i>
            </span>
          </button>

          <button
            type="button"
            class="button is-small tooltip"
            data-tooltip="Tambahkan gambar di bawah text"
            v-if="addons.indexOf('image_text') > -1"
            @click="showImagePrompt(commands.image)"
          >
            <span class="icon">
              <i class="fas fa-images"></i>
            </span>
          </button>

          <button
            type="button"
            class="button is-small tooltip"
            data-tooltip="Tambahkan Berkas"
            v-if="addons.indexOf('document') > -1"
            @click="showFilePrompt"
          >
            <span class="icon">
              <i class="fas fa-paperclip"></i>
            </span>
          </button>

        </div>
      </editor-menu-bar>

      <editor-content :class="editText ? 'textarea height-body-auto' : ''" :editor="editor" :style="contentStyle" />

      <p class="help" v-if="!isEmpty(addons) && showFileTypesInfo">
        <strong>Tipe berkas yang dapat di unggah:</strong>
        <span v-if="addons.indexOf('document') > -1">pdf, ppt, pptx, xls, xlsx, doc, docx, </span>
        <span v-if="addons.indexOf('image_text') > -1">jpeg, jpg, png, </span>
        <span v-if="addons.indexOf('video') > -1">mp4, </span>
        <span v-if="addons.indexOf('youtube') > -1">youtube</span>.
      </p>
    </div>

    <div v-if="!editText" class="content">
      <span :class="textClass" v-html="text"></span>
    </div>

    <b-modal
      :active.sync="show_media_library_modal"
      v-if="!isEmpty(addons)"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-modal>
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head has-background-primary">
          <p class="modal-card-title has-text-white">Media Library</p>
        </header>
        <section class="modal-card-body">
          <media-library
            :multiple="multiple_media"
            :types="media_types"
            :mediaCatcher="mediaCatcher"
            :onClickCancel="() => show_media_library_modal = false"
            :max="5"
            :selected_ids="selected_media_ids"
          ></media-library>
        </section>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { Editor, EditorContent, EditorMenuBar } from 'tiptap';
import {
  Blockquote,
  HardBreak,
  Heading,
  HorizontalRule,
  OrderedList,
  BulletList,
  ListItem,
  TodoItem,
  TodoList,
  Bold,
  Code,
  Italic,
  Strike,
  Underline,
  History,
  Image
} from 'tiptap-extensions';
import Paragraph from './tiptap-extensions/paragraph.js';
import BlankAutoLink from './tiptap-extensions/blankautolink.js';

export default {
  components: {
    EditorMenuBar,
    EditorContent
  },

  props: {
    multiple_media: {
      type: Boolean,
      default: false
    },
    addons: {
      type: Array,
      default: () => []
    },
    text: {
      type: String,
      default: () => ''
    },
    onSave: {
      type: Function,
      default: () => {}
    },
    onUpdate: {
      type: Function,
      default: () => {}
    },
    editText: {
      type: Boolean,
      default: false
    },
    onSelectedFile: {
      type: Function,
      default: () => {}
    },
    toolbars: {
      type: Array,
      default: () => ['bold', 'italic', 'strike', 'underline', 'code', 'paragraph', 'heading1', 'heading2', 'heading3', 'paragraph_left', 'paragraph_center', 'paragraph_right', 'paragraph_justify', 'bullet_list', 'ordered_list', 'blockquote', 'horizontal_rule', 'undo', 'redo']
    },
    selected_media_ids: {
      type: Array,
      default: () => []
    },
    textClass: {
      type: String,
      default: ''
    },
    showFileTypesInfo: {
      type: Boolean,
      default: true
    },
    contentStyle: {
      type: String,
      default: ""
    },
    onBlur: {
      type: Function,
      default: () => {}
    },
    loading: {
      type: Boolean,
      default: false
    },
    autoFocus: {
      type: Boolean,
      default: false
    },
    show_leave_page_confirmation: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    media_types() {
      let types = this.addons

      if (types.indexOf('image_text') > -1) {
        types = types.filter(type => type != 'image_text' || type != 'image')
        types.push('image')
      }

      return types
    }
  },

  watch: {
    text(newVal) {
      if (this.loading) {
        this.editor.setContent(newVal);
      }
    },
    editText(val) {
      this.editor.setOptions({
        editable: val
      });

      if (!val) {
        this.onSave(this.editor.getHTML());
      }
    }
  },

  data() {
    return {
      editor: null,
      active_command: null,
      media_library_type: null,
      show_media_library_modal: false
    }
  },

  mounted() {
    const vm = this;
    this.init();

    if (this.show_leave_page_confirmation) {
      window.onbeforeunload = function(event) {
        if (vm.editText) {
          return '';
        }
      }; 
    }
  },

  beforeUpdate() {
    if (!this.editText) {
      this.editor.destroy()
      this.init();
    }
  },

  beforeDestroy() {
    this.editor.destroy()
  },

  methods: {
    init() {
      const vm = this;
      this.editor = new Editor({
        extensions: [
          new Blockquote(),
          new BulletList(),
          new HardBreak(),
          new Heading({ levels: [1, 2, 3] }),
          new HorizontalRule(),
          new ListItem(),
          new OrderedList(),
          new TodoItem(),
          new TodoList(),
          new BlankAutoLink(),
          new Bold(),
          new Code(),
          new Italic(),
          new Strike(),
          new Underline(),
          new Image(),
          new History(),
          new Paragraph()
        ],
        autoFocus: (vm.autoFocus) ? 'end' : false,
        editable: vm.editText,
        content: vm.text,
        onUpdate: ({ getHTML }) => {
          this.onUpdate(getHTML());
        },
        onBlur: () => {
          this.onBlur(vm.text);
        },
      })
    },
    showImagePrompt(command) {
      this.show_media_library_modal = true
      this.active_command = command;
      this.media_library_type = 'image_text'
      // const src = prompt('Enter the url of your image here')
      // if (src !== null) {
      //   command({ src })
      // }
    },
    showFilePrompt() {
      this.show_media_library_modal = true
      this.media_library_type = 'document'
    },
    mediaCatcher(medias) {
      const vm = this;
      if (!this.isEmpty(medias)) {
        let media = medias[0];

        if (this.media_library_type == 'image_text') {
          if (!this.isEmpty(media.original_url) && media.storageType == null) {
            this.active_command({src: media.original_url});
          } else if (media.storageType == 'google_drive') {
            this.active_command({src: media.values.thumbnailLink})
          }
        } else {
          vm.onSelectedFile(vm.multiple_media ? medias : media)
        }
      }

      this.show_media_library_modal = false
    }
  }
}
</script>

<style>
  .height-body-auto {
    min-height: 50px !important;
    height: auto !important;
    max-height: none !important;
  }

  .ProseMirror:focus {
    outline: none !important;
  }
</style>
